<div id="lesson-info">
    <h4 class="mb-4">Información de la lección</h4>
    
    <p><span class="fw-bold">Nombre:</span> {{ name }}</p>
    
    <p><span class="fw-bold">Nº de enunciados:</span> {{ headingsNum }}</p>
</div>